import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import Modal from "react-bootstrap/Modal";
import "./modalAvisoHome.scss";
import { memo } from "react";
import React, { useEffect } from "react";
import Titulo from "../../../atoms/titles/Titulo";
import { useLocalStorage } from "../../../../hooks/useLocalStorage";
import ButtonCard from "../../../atoms/buttons/ButtonCard";

registerLocale("es", es);

const ModalAvisoHome = (object) => {
    const [token] = useLocalStorage("token", "");


    useEffect(() => { }, [token]);
   

    function modalAvisoHome() {
        return (
            <Modal
                className="infModal fechas z-index-1055"
                show={object.show}
                onHide={object.handleClose}
                backdrop="static"
                size="lg"
            >
                <Modal.Header>
                    <Modal.Title>
                        {/* <Titulo titulo={"Aviso"} tipo={"tituloModal"} /> */}
                        <h4 className="tituloModal">Aviso</h4>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="caja_formulario col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12">
                        {object.titulo ? (
                            <Titulo
                                titulo={object.titulo}
                                tipo={`text-center ${object.tipo}`}
                            />
                        ) : null}
                        {object.texto ? <p>{object.texto}</p> : null}
                        {object.texto2 ? <p>{object.texto2}</p> : null}
                        {object.alerta ? (<>
                            <div role="alert">
                                <p>{object.alerta}</p>
                            </div>
                        </>) : null}
                        {object.content ? (
                            <>
                                <p className={`fs-7 ${object?.contentClass}`}>
                                    {object.content}{" "}
                                </p>
                                <span className="fw-bold fs-5">{object.contentBold2}</span>{" "}
                                <p className={`fs-7 ${object?.contentClass}`}>
                                    {object.content2}{" "}
                                </p>
                            </>
                        ) : null}
                        {object.otherContent ? <h5>{object.otherContent}</h5> : null}
                    </div>
                    { }

                    <ButtonCard
                        id="btnAceptar"
                        clases="btn-card mt-2 rounded"
                        nombre={"Entendido"}
                        funcion={() => {
                            localStorage.removeItem("showModalHome")
                            object.handleClose();
                        }}
                    />

                </Modal.Body>
            </Modal>
        );
    }

    return <>{modalAvisoHome()}</>;
};

export default memo(ModalAvisoHome);
